import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationHistoryService {
  private previousNonSettingsUrl: string | null = null;
  private backButtonVisible = false;

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (!event.urlAfterRedirects.startsWith('/settings')) {
          this.previousNonSettingsUrl = event.urlAfterRedirects;
          this.backButtonVisible = false;
        }
      });
  }

  getReturnUrl(fallback = '/asset-management/asset-overview'): string {
    return this.previousNonSettingsUrl ?? fallback;
  }

  setBackButtonVisible(visible: boolean): void {
    this.backButtonVisible = visible;
  }

  isBackButtonVisible(): boolean {
    return this.backButtonVisible;
  }
}
